import { useRef } from 'react'

import { ReviewStage } from '@/entities/contract'
import { WithSuspenseBoundary } from '@/shared/api'
import { Dialog } from '@/shared/ui'

import { ReviewDialogFallback, ReviewDialogLoadingFallback } from './fallback'
import { ReviewForm, ReviewFormRef } from './review-form'

type Props = {
  initialContractId: number
  type: ReviewStage
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onClose: () => void
}

export const ContractReviewDialog = ({
  initialContractId,
  type,
  isOpen,
  onOpenChange,
  onClose,
}: Props) => {
  const formRef = useRef<ReviewFormRef | null>(null)

  const handleOpenChange = (open?: boolean) => {
    if (!open) {
      return
    }

    onOpenChange(open)
  }

  const handleClose = async () => {
    await formRef.current?.submitForm()
    onClose()
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content className="h-[714px] gap-0 p-0" onClose={handleClose}>
        <Dialog.Header className="gap-4 p-6">
          <Dialog.Title className="text-start">
            {type === ReviewStage.CHECK_IN
              ? '입주한 집은 어떠신가요?'
              : '머무른 집은 어떠셨나요?'}
          </Dialog.Title>
          <Dialog.Description className="typo-label1 text-start font-normal text-gray-600">
            남겨주신 리뷰는 호스트에게 큰 응원이 됩니다
          </Dialog.Description>
        </Dialog.Header>
        <WithSuspenseBoundary
          error={<ReviewDialogFallback />}
          loading={<ReviewDialogLoadingFallback />}
          active
        >
          <ReviewForm
            ref={formRef}
            initialContractId={initialContractId}
            type={type}
            onClose={onClose}
          />
        </WithSuspenseBoundary>
      </Dialog.Content>
    </Dialog.Root>
  )
}
